import request from '@/utils/request'

export function getUserInfo (obj) {
  return request({
    url: '/user/info',
    method: 'post',
    data: obj
  })
}

export function getList (data) {
  return request({
    url: '/queryDemoList', // 后端接口
    method: 'post',
    data
  })
}

export function delList (data) {
  return request({
    url: '/delDemo', // 后端接口
    method: 'post',
    data
  })
}
